// extracted by mini-css-extract-plugin
module.exports = {"warning":"DeleteEditEmployeeBtn__warning--GTtbQ","delete":"DeleteEditEmployeeBtn__delete--3qM_8","edit":"DeleteEditEmployeeBtn__edit--32_19"};